export const isEmptyAttribution = (attribution) => {
  if (!attribution || attribution === "" || attribution === "<p><br></p>")
    return true

  return false
}
